<template>
  <v-app style="background-color: #E9CFED !important;
  border: none !important;
  margin: 0 !important;
  padding: 0 !important;">
    <v-main>
      <v-container fill-height>
        <v-row justify="center" align="center">
          <v-col cols="12">

            <div class="d-flex justify-center pb-8">
              <v-img
              lazy-src="/gpd_logo.png"
              src="/gpd_logo.png"
              max-width="250"
              ></v-img>
            </div>

            <h1 v-if="!error" class="h1 pb-8 text-center">Reset Password</h1>

            <validation-observer
              ref="email"
              v-slot="{ invalid }"
            >
              <v-form @submit.prevent="submit" v-if="!error">
                <v-row>
                  <v-col
                      cols="12"
                      md="6"
                      offset-md="3"
                    >
                    <v-row>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <validation-provider name="Password" vid="password" rules="required" v-slot="{ errors }">
                          <v-text-field
                            class="entrada-dados"
                            v-model="password"
                            label="Password *"
                            type="password"
                            prepend-inner-icon="mdi-form-textbox-password"
                            :error-messages="errors"
                            rows="1"
                            solo
                            flat
                            hide-details
                          ></v-text-field>
                        </validation-provider>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <validation-provider name="Confirmação Password" vid="password_confirmation" rules="required|password:@password" v-slot="{ errors }">
                          <v-text-field
                            class="entrada-dados-pass"
                            v-model="password_confirmation"
                            label="Confirmação Password *"
                            type="password"
                            prepend-inner-icon="mdi-form-textbox-password"
                            :error-messages="errors"
                            rows="1"
                            solo
                            flat
                            hide-details
                          ></v-text-field>
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    offset-md="3"
                  >
                    <v-btn
                      depressed
                      color="black"
                      dark
                      class="mr-4"
                      type="submit"
                      :disabled="invalid"
                      large
                      block
                    >
                      Confirmar
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
              <v-row v-else>
                <v-col
                    cols="12"
                    md="6"
                    offset-md="3"
                  >
                  <h2 class="error--text text-center">Não é possível ativar a sua conta</h2>
                  <p class="body-1 text-center mt-5">Para ativar a sua conta, entre em contacto para: <a class="text-decoration-none font-weight-bold secundary--text" :href="'mailto:' + email">{{email}}</a></p>
                  <p>Erro: {{errorText}}</p>
                  <v-row class="mt-5">
                    <v-col
                      cols="12"
                      md="6"
                      offset-md="3"
                    >
                      <v-btn
                        depressed
                        color="primary"
                        class="mr-4"
                        type="button"
                        large
                        block
                        link
                        to="/"
                      >
                        Página Inicial
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </validation-observer>
             <div class="d-flex justify-center mb-5 mt-5">
              <v-img
                lazy-src="@/assets/mc_logo.png"
                src="@/assets/mc_logo.png"
                max-width="150"
                @click="$router.push('/')"
                style="cursor:pointer;"
              ></v-img>
            </div>            
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-footer style="background-color: #E9CFED !important;" app fixed>
      <span class="body-2" style="color:white; margin: auto; display: block;">Powered By <a target="_blank" href="https://www.dreamdealtech.pt/">Dreamdeal Technologies</a></span>
    </v-footer>
  </v-app>
</template>
<script>
import User from "@/api/User.js"

export default {
  components: {
  },
  data: () => ({
    password: "",
    password_confirmation: "",
    error: false,
    errorText:"",
  }),
  beforeCreate(){

    document.title = "MatchCalendar - Confirmação Email";

    if(localStorage['auth'] == 1){
      this.$router.push('/home');
    }
  },
  computed: {
    email: function(){
      return process.env.VUE_APP_EMAIL;
    }
  },
  methods:{
    submit () {
        this.$refs.email.validate().then((valid) => {
          if (!valid) {
            return;
          }

          let payload = {
            id: this.$route.params.id,
            password: this.$encryptValue(this.password),
            password_confirmation: this.$encryptValue(this.password_confirmation),
          }

          User.confirmEmail(payload)
            .then(() => {

                this.$router.push('/');

                
            }).catch(err => {

              if(err.response.status == 422) {

                this.$refs.email.setErrors(err.response.data.errors);
                
                return;
              }

              this.error = true;

              this.errorText = err.message

          });
        });
      },
  }
};
</script>

<style scoped>


.footer-content {
  position: fixed;
  bottom: 10px; /* Distância do fundo da página */
  left: 50%;
  transform: translateX(-50%); /* Alinha o conteúdo ao centro horizontalmente */
  text-align: center;
  color: white;
  width: 100%;
  z-index:1000
}


.entrada-dados-pass {
  width: 100%;
  min-width: 300px;
  box-sizing: border-box;
}

.entrada-dados .v-input__control{
  border-radius: 30px !important;
  box-shadow: none !important;
  width: 100% !important;
}

.entrada-dados-pass .v-input__control{
  border-radius: 30px !important;
  box-shadow: none !important;
  width: 100% !important;
}

.entrada-dados .v-input.v-input--is-solo {
  background: rgba(255, 255, 255, 0,5) !important;
  border-radius: 30px !important;
}

.entrada-dados-pass .v-input.v-input--is-solo {
  background: rgba(255, 255, 255, 0,5) !important;
  border-radius: 30px !important;
}

</style>
